import { followActionType } from "./constains";

const INITIAL_STATE = {
    isLoading: null,
    isFollowerLoaded: false,
    errorMessage: {},
    followers: null,
    totalFollowers: null,
    following: null,
    isFollowingLoaded: false,
    totalFollowing: null
};

export function followReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
      case followActionType.FOLLOWERS_LOADING_START:
        return {
          ...state,
          isLoading: true,
          isFollowerLoaded: false,
        };
      case followActionType.FOLLOWERS_LOADING_SUCCESS:
        return {
          ...state,
          followers: action.payload.followers,
          totalFollowers: action.payload.totalFollowers,
          isLoading: false,
          isFollowerLoaded: true,
        };
      case followActionType.FOLLOWERS_LOADING_ERROR:
        return {
          ...state,
          errorMessage: action.payload,
          isLoading: false,
          isFollowerLoaded: false,
        };
      case followActionType.FOLLOWING_LOADING_START:
        return {
          ...state,
          isLoading: true,
          isFollowingLoaded: false,
        };
      case followActionType.FOLLOWING_LOADING_SUCCESS:
        return {
          ...state,
          following: action.payload.following,
          totalFollowing: action.payload.totalFollowing,
          isLoading: false,
          isFollowingLoaded: true,
        };
      case followActionType.FOLLOWING_LOADING_ERROR:
        return {
          ...state,
          errorMessage: action.payload,
          isLoading: false,
          isFollowingLoaded: false,
        };

      default:
        return state;
    }
  }
  